import { jsx as i } from "react/jsx-runtime";
import { aj as f, aE as x, aF as _, d as m } from "../../vendor-CPVnY93G.js";
import { useRef as l } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { useAutoResize as b, supportsFieldSizing as d } from "./useAutoResize.js";
import '../../assets/index57.css';const u = "_textArea_1rxqv_1", v = "_autoResize_1rxqv_44", $ = "_both_1rxqv_48", A = "_vertical_1rxqv_52", R = "_none_1rxqv_56", t = {
  textArea: u,
  autoResize: v,
  both: $,
  vertical: A,
  none: R
};
function S({
  className: a,
  resize: s = "both",
  autoResize: o = !1,
  maxRows: c,
  ...r
}) {
  const e = l(null), [{ value: n }] = f(r, e, x);
  return b(e, { isEnabled: o, value: n, maxRows: c }), /* @__PURE__ */ i(
    _,
    {
      ...p(r),
      ref: e,
      className: m(t.textArea, t[s], a, {
        [t.autoResize]: o && d
      }),
      "data-component": "TextArea"
    }
  );
}
export {
  S as TextArea
};
